import { Button } from "@unbxd-ui/unbxd-react-components";
import { useRef, useEffect } from "react";

function VisualSearchCamera(props) {
    const { canvas, base64Payload, 
        setStartCamera, setShowCanvas, setIsImageCaptured, setCanvasSrc, startCamera } = props;

    

    var streaming = useRef(false);

    var video = useRef(null);
    
    

    const takepicture = () => {
            canvas.current.width = video.current.clientWidth;
            canvas.current.height = video.current.clientHeight;
            var context = canvas.current.getContext('2d');
            context.drawImage(video.current, 0, 0, canvas.current.width, canvas.current.height);
            base64Payload.current = canvas.current.toDataURL().split(';base64,')[1];
            setIsImageCaptured(true);
    }

    const onCaptureClick = (evt) => {
        setStartCamera(false);
        setIsImageCaptured(false);
        setShowCanvas(true);
        takepicture();
        evt.preventDefault();
    }

    function setupCamera() {
        video.current = document.getElementById('video');
        canvas.current = document.getElementById('canvas');
        
        

        const getFacingMode = () => {
            let userAgentString = window.navigator.userAgent.toLowerCase();
            let mobileStrings = ["ipad","android","iphone"];
            // let isMobile = false;
            // mock for test
            let isMobile = false;
            for (var i=0;i<mobileStrings.length;i++) {
                if(userAgentString.indexOf(mobileStrings[i]) > -1) {
                    isMobile = true;
                }
            }
            
            
            if(isMobile) {
                return {
                    exact: 'environment'
                }
            } else {
                return 'user'
            }
        }

        
            window.navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: getFacingMode()
                    
                },
                audio: false
            })
                .then(function (stream) {
                    
                    video.current.srcObject = stream;
                    video.current.play();
                   
                })
                .catch(function (err) {
                    
                    console.log("An error occurred: " + err);
                });
    }

    const onCanPlayVideo = () => {
        if (!streaming.current) {
            let vw = video.current.videoWidth;
            let vh = video.current.videoHeight;
           
            let aspectRatio = vw/vh;
            let targetWidth = document.body.clientWidth * 70 / 100;
            video.current.width = targetWidth;
            
                    if(aspectRatio < 1) {
                        video.current.height = targetWidth/aspectRatio;
                        if(video.current.height > document.body.clientHeight) {
                            while(video.current.height >= document.body.clientHeight) {
                                targetWidth = targetWidth * 80 / 100;
                                video.current.height = targetWidth/aspectRatio;
                            }
                        }
                    } else {
                        /** Only for ipad, video takes both orientations in portrait mode
                         * Forcefully make video orientation vertical mode which will
                         * avoid extra content being drawn on canvas
                         */
                        let userAgentString = window.navigator.userAgent.toLowerCase();
                        let mobileStrings = ["ipad"];
                        let isIpad = false;
                        for (var i=0;i<mobileStrings.length;i++) {
                            if(userAgentString.indexOf(mobileStrings[i]) > -1) {
                                isIpad = true;
                            }
                        }
                        if((document.body.clientHeight > document.body.clientWidth)) {
                            /** Portrait mode but video in landscape orientation */
                            video.current.height = targetWidth*aspectRatio;
                            if(video.current.height > document.body.clientHeight) {
                                while(video.current.height >= document.body.clientHeight) {
                                    targetWidth = targetWidth * 80 / 100;
                                    video.current.height = targetWidth*aspectRatio;
                                }
                            }
                        } else {
                            video.current.style.height = "100%";
                            video.current.width = video.current.clientHeight * aspectRatio;
                            while(video.current.width >= document.body.clientWidth) {
                                video.current.style.height = video.current.clientHeight * 90 / 100;
                                video.current.width = video.current.clientHeight * aspectRatio;
                            }
                        }
                    }
                    
            streaming.current = true;
        }
    }

    useEffect(() => {
        setupCamera();
    }, []);

    return (
        <div className={`camera-container`}>
            <div className="camera">
                <video id="video" onCanPlay={onCanPlayVideo}></video>
            </div>
            <div className="capture-button-container"><Button className="img-capture-button" onClick={onCaptureClick}></Button></div>
        </div>
    )
}

export default VisualSearchCamera;